<template>
  <div>
    <div ref="lableBtnRef2" class="cart-button" @click="openDrawer">
      <div class="cart-icon-container">
        <img class="cart-icon" :src="cards01" alt="购物车" />
        <div class="cart-text">采购清单</div>
        <div v-show="tableData.length > 0" class="cart-badge">
          {{ tableData.length }}
        </div>
      </div>
    </div>

    <el-drawer
      v-model="drawer"
      title="采购清单"
      size="45%"
      destroy-on-close
      @close="handleDrawerClose"
    >
      <template #header>
        <h4 style="padding-left: 10px">采购清单</h4>
      </template>
      <div class="draw_box">
        <!-- 加载状态 -->
        <el-skeleton :rows="5" animated v-if="loading" />

        <!-- 空状态 -->
        <el-empty
          v-else-if="tableData.length === 0"
          description="购物车空空如也"
        >
          <el-button type="primary" @click="goShopping">去采购</el-button>
        </el-empty>

        <!-- 正常数据状态 -->
        <template v-else>
          <el-table
            ref="multipleTableRef"
            :data="tableData"
            row-key="id"
            @selection-change="handleSelectionChange"
            :row-style="{ height: '100px', width: '100%' }"
            v-loading="tableLoading"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 255, 255, 0.7)"
          >
            <el-table-column
              show-overflow-tooltip
              type="selection"
              :selectable="selectable"
            />
            <el-table-column label="知识库名称" show-overflow-tooltip>
              <template #default="scope">{{
                scope.row.knwoledgeTitle
              }}</template>
            </el-table-column>
            <!-- <el-table-column show-overflow-tooltip label="价格">
              <template #default="scope">
                ￥{{
                  scope.row.knowledgeVersion === "netVersion"
                    ? getNetPrice(scope.row)
                    : scope.row.mirrorPrice
                }}
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="并发数" width="100">
              <template #default="scope">
                <el-select
                  v-if="scope.row.knowledgeVersion === 'netVersion'"
                  v-model="scope.row.selectedConcurrent"
                  @change="handleConcurrentChange(scope.row, $event)"
                  placeholder="20"
                  size="small"
                >
                  <el-option label="20" value="20"></el-option>
                  <el-option label="50" value="50"></el-option>
                  <el-option label="100" value="100"></el-option>
                  <el-option label="200" value="200"></el-option>
                </el-select>
                <span v-else>-</span>
              </template>
            </el-table-column> -->
            <el-table-column label="版本">
              <template #default="scope">
                <el-select
                  v-if="
                    scope.row.netVersion === 1 && scope.row.mirrorVersion === 1
                  "
                  v-model="scope.row.knowledgeVersion"
                  @change="handleVersionChange(scope.row, $event)"
                  placeholder="网络版本"
                  size="small"
                >
                  <el-option label="网络版本" value="netVersion"></el-option>
                  <el-option label="镜像版本" value="mirrorVersion"></el-option>
                </el-select>
                <span v-else>
                  {{
                    scope.row.knowledgeVersion === "netVersion"
                      ? "网络版本"
                      : "镜像版本"
                  }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="年限">
              <template #default="scope">
                <el-input-number
                  v-model="scope.row.years"
                  :min="scope.row.knowledgeVersion === 'mirrorVersion' ? 3 : 1"
                  :max="10"
                  @change="(val) => handleChange(scope.row, val)"
                  size="small"
                  style="width: 80px"
                  :placeholder="
                    scope.row.knowledgeVersion === 'mirrorVersion' ? '3' : '1'
                  "
                />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template #default="scope">
                <el-button
                  type="danger"
                  size="small"
                  style="border-radius: 0"
                  @click="handleDelete(scope.row)"
                  plain
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="cardtableboe">
            <div style="padding-top: 8px">
              <el-button
                style="border-radius: 0"
                type="danger"
                v-show="tableData.length > 0"
                @click="handleClickDelete(tableData)"
                size="small"
                plain
                >一键清空</el-button
              >
            </div>

            <div class="cardtable_right">
              <div class="summary-item">
                <span class="summary-label">已选:</span>
                <span class="summary-value"
                  >{{ multipleSelection.length }}件</span
                >
              </div>
              <!-- <div class="summary-item total-price">
                <span class="summary-label">合计</span>
                <span class="summary-value">{{ totalInWan }}万</span>
              </div> -->
              <div class="action-buttons">
                <el-button
                  type="warning"
                  class="custom-button2"
                  @click="closedraw(0)"
                  size="small"
                  >申请试用</el-button
                >
                <el-button
                  type="primary"
                  class="custom-button"
                  @click="closedraw(1)"
                  size="small"
                  >购买</el-button
                >
              </div>
            </div>
          </div>
        </template>
      </div>
    </el-drawer>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick, onUnmounted, computed } from "vue";
import { Cookie } from "@/utils/Cookie";
import {
  PostAddCardList,
  PostGetCardList,
  PostDeleteCardList,
  PostUpdateCardList,
  PostOrderDeleteList,
  // PostselectKnowledgeBaseList,
} from "@/api/index.js";
import { useOrderStore } from "@/views/stores/order";

import cardimg from "@/assets/headerimage/cardshoping.png";
import cards01 from "@/assets/headerimage/cards01.png";
import { ElMessage } from "element-plus";
import bus from "@/mitt/bus.js";
import { useRouter } from "vue-router";

const loading = ref(true); // 初始加载状态
const tableLoading = ref(false); // 表格加载状态
const lableBtnRef = ref(null);
const lableBtnRef2 = ref(null);
const tableData = ref([]);
const drawer = ref(false);
const multipleTableRef = ref(null);
const multipleSelection = ref([]);
const router = useRouter();
const num = ref(1);

const handleDrawerClose = () => {
  // 打开时也可以重置状态
  multipleSelection.value = [];
  if (multipleTableRef.value) {
    multipleTableRef.value.clearSelection();
  }
};

const handleClickDelete = (data) => {
  handleClearOrder(data);
};

// 添加检查登录状态的函数
const checkLoginStatus = () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token) return false;

  try {
    const parts = token.split(".");
    if (parts.length !== 3) return false;

    const payload = JSON.parse(atob(parts[1]));
    // 检查token是否过期
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      return false;
    }
    return true;
  } catch (e) {
    console.error("Token验证错误:", e);
    return false;
  }
};

const handleClearOrder = async (dataValue) => {
  try {
    // First check login status
    const isLoggedIn = checkLoginStatus();

    if (!isLoggedIn) {
      // User not logged in - clear local cache
      localStorage.removeItem("addCardListParams");
      tableData.value = []; // Clear local data
      ElMessage.success("已清空购物车");
      return;
    } else {
      localStorage.removeItem("addCardListParams");
      tableData.value = []; // Clear local data
    }

    // User is logged in - proceed with API call
    const transformData = (data) => {
      if (!Array.isArray(data)) return [];

      return data
        .filter(
          (item) => item && typeof item === "object" && item.id !== undefined
        )
        .map((item) => ({
          id1s: String(item.id),
        }));
    };

    const dataList = transformData(dataValue || []);
    if (dataList.length === 0) {
      ElMessage.warning("没有可清空的有效数据");
      return;
    }

    let jsonArray = [];
    try {
      const idArray = dataList.map((item) => item.id1s);
      jsonArray = Array.from(new Set(idArray)); // Remove duplicates
    } catch (e) {
      console.error("构建ID数组失败:", e);
      // console.log("数据处理失败");
    }

    // Make API call to clear server-side cart
    const res = await PostOrderDeleteList({ id1s: jsonArray }).catch(
      (error) => {
        console.error("API调用失败:", error);
        // console.log("清空操作失败");
      }
    );

    if (res?.info) {
      // Also clear local cache for consistency
      localStorage.removeItem("addCardListParams");
      await cardTableList(); // Refresh the list
      ElMessage.success("已全部清空");
    } else {
      console.log(res?.message || "清空操作未成功");
      // console.log(res?.message || "清空操作未成功");
    }
  } catch (error) {
    console.error("清空订单出错:", error);
    if (error.message.includes("登录过期") || error?.response?.status === 401) {
      ElMessage.error("登录过期，请重新登录");
      router.push("/login");
    } else {
      ElMessage.error(`清空失败: ${error.message || "未知错误"}`);
    }
  }
};

// 计算属性：合计价格（万元）
const totalInWan = computed(() => {
  const total = multipleSelection.value.reduce((sum, item) => {
    const price =
      item.knowledgeVersion === "netVersion"
        ? getNetPrice(item)
        : item.mirrorPrice;
    const years = item.years || 1; // 默认1年
    return sum + (price || 0) * years;
  }, 0);
  return (total / 10000).toFixed(2);
});

onMounted(() => {
  // getResourceContent();
  cardTableList();
  bus.on("sendMsg", (data) => {
    handleCustomEvent(data.card, data.event, data.lableBtn);
  });
});

onUnmounted(() => {
  bus.off("sendMsg");
});

const openDrawer = async () => {
  cardTableList();
  drawer.value = true;
};

const cardNum = ref(0);
// const selectable = (row) => ![1, 2].includes(row.id);
const selectable = (row) => ref(true);

// const getResourceContent = async () => {
//   try {
//     const params = { pageIndex: "1", pageSize: "10", contentCId: "385" };
//     const response = await PostselectKnowledgeBaseList(params);
//     if (!response.info) {
//       console.log("接口返回的数据为空或格式不正确");
//     }
//   } catch (error) {
//     console.error("获取数据失败:", error);
//   }
// };

const cardTableList = async () => {
  try {
    tableLoading.value = true;
    loading.value = true;
    const isLoggedIn = checkLoginStatus();

    if (!isLoggedIn) {
      tableData.value = JSON.parse(
        localStorage.getItem("addCardListParams") || "[]"
      );
      return;
    } else {
      //  tableData.value = JSON.parse(
      //   localStorage.getItem("addCardListParams") || "[]"
      // );
      // return
    }

    const res = await PostGetCardList();

    if (res?.info) {
      tableData.value = res.info.map((item) => ({
        ...item,
        currentVersion: item.currentVersion || "net",
        selectedConcurrent: item.knowledgeVersion === "netVersion" ? "20" : "",
        years: item.knowledgeVersion === "mirrorVersion" ? 3 : 1,
      }));
    } else {
      // tryUseCachedData();
    }
  } catch (error) {
    console.error("请求出错:", error);
    // tryUseCachedData();
    if (error.response?.status === 401) {
      ElMessage.warning("登录已过期，请重新登录");
      router.push("/login");
    }
  } finally {
    loading.value = false;
    tableLoading.value = false;
  }
};

//确保获取有效 token
const ensureValidToken = () => {
  return new Promise((resolve) => {
    const checkToken = () => {
      const token = JSON.parse(Cookie.get("token")) || "";
      if (token) {
        resolve(token);
      } else {
        // 如果没有 token，等待 100ms 再检查
        setTimeout(checkToken, 100);
      }
    };
    checkToken();
  });
};
// addCardListParams

const goShopping = () => {
  router.push("/knowledge"); // 替换为你的商品列表路由
  drawer.value = false;
};

const handleSelectionChange = (val) => {
  multipleSelection.value = val;
};

const closedraw = (isding) => {
  if (multipleSelection.value.length === 0) {
    ElMessage.warning("请至少选择一项商品");
    return;
  }
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token) {
    router.push({
      path:'/login',
    });
  } else {
    // 准备订单项数据，确保包含并发数和年限
    const orderItems = multipleSelection.value.map((item) => ({
      ...item,
      // 保存当前价格（基于并发数和年限计算）
      currentPrice:
        item.knowledgeVersion === "netVersion"
          ? getNetPrice(item)
          : item.mirrorPrice,
      // 保存并发数（如果是网络版本）
      concurrentNum:
        item.knowledgeVersion === "netVersion"
          ? item.selectedConcurrent || "20"
          : null,
      // 保存年限
      years: item.years || 1,
      // 保存原始价格信息以便后续计算
      priceInfo: {
        netPrice: item.netPrice,
        netPrice20: item.netPrice20,
        netPrice50: item.netPrice50,
        netPrice100: item.netPrice100,
        netPrice200: item.netPrice200,
        mirrorPrice: item.mirrorPrice,
      },
    }));

    const orderStore = useOrderStore();
    orderStore.setOrderItems(orderItems);
    router.push({
      name: "orderPage",
      query: { isding },
    });
  }
};

const handleDelete = async (row) => {
  // 检查登录状态和token
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token) {
    // token不存在，直接在本地删除当前行
    const index = tableData.value.findIndex((item) => item.id === row.id);
    if (index > -1) {
      tableData.value.splice(index, 1);
      // 从缓存中删除对应的数据
      try {
        const cached = JSON.parse(
          localStorage.getItem("addCardListParams") || "[]"
        );
        const newCached = cached.filter((item) => item.id !== row.id);
        localStorage.setItem("addCardListParams", JSON.stringify(newCached));
      } catch (error) {
        console.error("清除缓存数据失败:", error);
      }
      return;
    }
  }

  try {
    const parts = token.split(".");
    if (parts.length !== 3) {
      // token格式不正确，直接在本地删除当前行
      const index = tableData.value.findIndex((item) => item.id === row.id);
      if (index > -1) {
        tableData.value.splice(index, 1);
        // 从缓存中删除对应的数据
        try {
          const cached = JSON.parse(
            localStorage.getItem("addCardListParams") || "[]"
          );
          const newCached = cached.filter((item) => item.id !== row.id);
          localStorage.setItem("addCardListParams", JSON.stringify(newCached));
        } catch (error) {
          console.error("清除缓存数据失败:", error);
        }
        return;
      }
    }

    const payload = JSON.parse(atob(parts[1]));
    // 检查token是否过期
    if (payload.exp && Date.now() >= payload.exp * 1000) {
      // token过期，直接在本地删除当前行
      const index = tableData.value.findIndex((item) => item.id === row.id);
      if (index > -1) {
        tableData.value.splice(index, 1);
        // 从缓存中删除对应的数据
        try {
          const cached = JSON.parse(
            localStorage.getItem("addCardListParams") || "[]"
          );
          const newCached = cached.filter((item) => item.id !== row.id);
          localStorage.setItem("addCardListParams", JSON.stringify(newCached));
        } catch (error) {
          console.error("清除缓存数据失败:", error);
        }
        return;
      }
    }

    if (typeof PostDeleteCardList !== "function") {
      console.error("PostDeleteCardList function is not defined");
      return;
    }

    const res = await PostDeleteCardList({ id1: row.id });
    if (typeof res === "object" && res !== null) {
      if (res.status === 200) {
        cardNum.value--;
        ElMessage.success("删除成功");
        cardTableList();
      } else {
        ElMessage.error(`删除失败，状态码: ${res.status}`);
      }
    } else {
      ElMessage.error("响应数据格式不正确");
    }
  } catch (error) {
    console.error("删除请求失败:", error);
    ElMessage.error("删除请求失败，请检查网络连接或稍后重试");
  }
};

const handleAddCardList = async (data) => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token) return;
  const params = {
    knowledgeId: data.id,
    knwoledgeTitle: data.title,
    publishUnit: data.publishUnit,
    knowledgeVersion: "netVersion",
    netVersion: data.netVersion,
    mirrorVersion: data.mirrorVersion,
    netPrice: data.netPrice,
    mirrorPrice: data.mirrorPrice,
    netPrice20: data.netPrice20,
    netPrice50: data.netPrice50,
    netPrice100: data.netPrice100,
    netPrice200: data.netPrice200,
  };
  try {
    const res = await PostAddCardList(params);
    if (res.status != 200) {
      ElMessage.warning(res.info);
    }
  } catch (error) {
    ElMessage.error(error.message || "请求发生错误");
  }
};

// 处理版本切换
const handleVersionChange = async (row) => {
  if (!row) {
    console.error("传入的 row 对象为空");
    return;
  }

  try {
    const wlSatus = row.knowledgeVersion;

    // Update years based on version
    row.years = wlSatus === "mirrorVersion" ? 3 : 1;

    const isLoggedIn = checkLoginStatus();

    if (isLoggedIn) {
      const res = await PostUpdateCardList({
        knowledgeVersion: wlSatus,
        id: row.id,
      });

      if (res && res.status === 200) {
        updateSelection(row);
      } else {
        ElMessage.error("切换失败");
      }
    } else {
      updateLocalVersion(row.id, wlSatus);
    }
  } catch (error) {
    console.error("请求发生错误:", error);
    ElMessage.error(error.message || "请求发生错误");
  }
};

// 辅助函数：更新选中状态
function updateSelection(row) {
  console.log(row, "row");

  if (multipleSelection && multipleSelection.value) {
    if (
      multipleSelection.value.some(
        (item) => item.id === row.id || row.knowledgeId
      )
    ) {
      if (typeof handleSelectionChange === "function") {
        handleSelectionChange([...multipleSelection.value]);
      } else {
        console.error("handleSelectionChange 不是一个有效的函数");
      }
    }
  }
}

function updateLocalVersion(id, newVersion) {
  const localData = JSON.parse(localStorage.getItem("knowledgeData") || "{}");
  if (localData[id]) {
    localData[id].knowledgeVersion = newVersion;
    localData[id].price = getPriceByVersion(newVersion);
    localStorage.setItem("knowledgeData", JSON.stringify(localData));
  }
}

function getPriceByVersion(version) {
  return version === "premium" ? 99.99 : 9.99;
}

const handleAddToCart = async (cards) => {
  // Convert single card to array for consistent processing
  const cardsArray = Array.isArray(cards) ? cards : [cards];
  // Filter out cards that are already in the tableData
  const newCards = cardsArray.filter((card) => {
    return !tableData.value.some((item) => {
      // 如果 card 的 knowledgeId 和 id 相同，就只匹配 knowledgeId
      if (card.knowledgeId && card.id && card.knowledgeId === card.id) {
        console.log(1);

        return item.knowledgeId === card.knowledgeId;
      } else if (item.knowledgeId && item.id === item.knowledgeId) {
        // console.log(2);

        return item.id === card.id;
      }

      // 否则，按 id 或 knowledgeId 任意匹配
      return item.knowledgeId === card.knowledgeId || item.id === card.id;
    });
  });

  if (newCards.length === 0) {
    return;
  }

  // Process each new card
  const processedCards = newCards.map((card) => {
    const processedCard = { ...card }; // Create a copy to avoid modifying original
    processedCard.knwoledgeTitle = processedCard.title || card.knwoledgeTitle;
    processedCard.id = processedCard.knowledgeId = card.id || card.knowledgeId;
    // Determine knowledgeVersion
    if (processedCard.netVersion === 1 && processedCard.mirrorVersion === 0) {
      processedCard.knowledgeVersion = "netVersion";
    } else if (
      processedCard.netVersion === 0 &&
      processedCard.mirrorVersion === 1
    ) {
      processedCard.knowledgeVersion = "mirrorVersion";
    } else if (
      processedCard.netVersion === 1 &&
      processedCard.mirrorVersion === 1
    ) {
      processedCard.knowledgeVersion = "netVersion";
    }

    return processedCard;
  });


  await Promise.all(processedCards.map((card) => handleAddCardList(card)));

  // Update tableData and localStorage
  tableData.value.push(...processedCards);
  localStorage.setItem("addCardListParams", JSON.stringify(tableData.value));
};
const handleCustomEvent = async (cards, event = {}, lableBtnevent) => {
  await handleAddToCart(cards);
  lableBtnRef.value = lableBtnevent;
  const x = event.clientX - 20;
  const y = event.clientY - 20;
  await nextTick();
  await createBall(x, y);
  cardTableList();
};

const createBall = (left, top) => {
  return new Promise((resolve) => {
    if (!lableBtnRef2.value) {
      console.error("lableBtnRef2 is null");
      return;
    }
    const bar = document.createElement("div");
    const lableBtn = lableBtnRef2.value;
    const rect = lableBtn.getBoundingClientRect();
    const size = [lableBtn.clientWidth, lableBtn.clientHeight];
    const afterX = rect.x + size[0] / 2;
    const afterY = rect.y + size[1] / 2;

    bar.classList.add("cartBall");
    bar.style.position = "fixed";
    bar.style.left = `${left}px`;
    bar.style.top = `${top}px`;
    bar.style.width = "20px";
    bar.style.height = "20px";
    bar.style.backgroundColor = "red";
    bar.style.borderRadius = "50%";
    bar.style.zIndex = "9999";
    bar.style.transition =
      "left 0.6s linear, top 0.6s cubic-bezier(0.5, -0.5, 1, 1)";
    document.body.appendChild(bar);

    requestAnimationFrame(() => {
      bar.style.top = `${afterY}px`;
      bar.style.left = `${afterX}px`;
    });

    bar.ontransitionend = () => {
      bar.remove();
      resolve();
    };
  });
};

// 新增 getNetPrice 方法
const getNetPrice = (row) => {
  const concurrent = row.selectedConcurrent;
  switch (concurrent) {
    case "20":
      return row.netPrice20;
    case "50":
      return row.netPrice50;
    case "100":
      return row.netPrice100;
    case "200":
      return row.netPrice200;
    default:
      return row.netPrice20;
  }
};

// 处理并发数切换
const handleConcurrentChange = (row, value) => {
  row.selectedConcurrent = value;
  handleSelectionChange([...multipleSelection.value]); // 重新计算合计
};

const handleChange = (row, value) => {
  row.years = value;
  handleSelectionChange([...multipleSelection.value]); // 重新计算合计
};
</script>

<style scoped>
.cart-button {
  position: fixed;
  right: 41px;
  bottom: 238px;
  z-index: 1000;
  cursor: pointer;
  width: 62px;
  height: 164px;
  background: #2c77ff;
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
.cart-button :hover {
  background: #2565d9;
  border-radius: 6px;
}
.cart-icon-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  width: 100%;
  height: 100%;
  padding-top: 20px;
}
.cart-icon {
  width: 25px;
  height: 25px;
  object-fit: contain;
}

.cart-text {
  writing-mode: vertical-rl;
  text-orientation: upright;
  font-size: 12px;
  color: white;
  line-height: 1;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  text-align: justify;
  font-style: normal;
  letter-spacing: 8px;
  padding-top: 10px;
}

.cart-badge {
  position: absolute;
  top: 10px;
  right: 5px;
  background: #ff4d4d;
  color: white;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  line-height: 1;
  font-weight: bold;
}

.el-skeleton {
  padding: 20px;
}

/* 空状态容器样式 */
.el-empty {
  padding: 40px 0;
}
.cardshoping {
  position: fixed;
  width: 62px;
  height: 164px;
  z-index: 1000;
  right: 0;
  bottom: 200px;
  cursor: pointer;
  background: #2c77ff;
  border-radius: 6px;
}

.cardshoping.img {
  position: relative;
  width: 62px;
  height: 164px;
  background: #2c77ff;
  border-radius: 6px;
}
.cardNum {
  position: absolute;
  right: 3px;
  bottom: 63px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: red;
  text-align: center;
  line-height: 18px;
  font-size: 12px;
  color: #fff;
}

.cardtableboe {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}
.draw_box {
  opacity: 1;
  background: rgba(255, 255, 255);
}

.custom-button {
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  background: rgba(31, 85, 222, 1);
  border-radius: 0;
  width: 149px;
  height: 42px;
  opacity: 1;
}
.custom-button2 {
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  border-radius: 0;
  width: 149px;
  height: 42px;
  opacity: 1;
  background: #e6a23c;
}

.cardtable_right {
  display: flex;
  justify-content: space-around;
  width: 500px;
  margin-right: 58px;
  line-height: 42px;
}
.cartBall {
  width: 50px;
  height: 50px;
  z-index: 99;
  background: url(@/assets/image/cardIcon.png);
}
/* .cell el-tooltip {
  width: 100px;
  text-align: center;
} */
:deep(.el-drawer__header) {
  align-items: baseline;
  color: #fff;
  display: flex;
  margin-bottom: 0;
  padding: var(--el-drawer-padding-primary);
  padding-bottom: 0;
  background: #2c77ff;
  height: 64px;
}
::v-deep(.el-scrollbar__bar){
  display: none;
}
</style>
